'use client';
import React, { useEffect, useState } from 'react';

const videos = [
  {
    type: 'iframe' as const,
    src: 'https://player.cloudinary.com/embed/?cloud_name=ldbaoyjh&public_id=91744-636709154&autoplay=true&muted=true&loop=true&controls=false',
  },
  {
    type: 'video' as const,
    src: 'https://res.cloudinary.com/ldbaoyjh/video/upload/v1786974466/110923-689949643.mp4',
  },
];

export default function Hero() {
  const [visible, setVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    setVisible(true);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % videos.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section
      id="home"
      className="relative w-full min-h-[85vh] flex items-center justify-center overflow-hidden"
      style={{
        backgroundColor: '#050F1E',
        backgroundImage: 'url(https://images.unsplash.com/photo-1486325212027-8081e485255e?w=1600&q=80&auto=format&fit=crop)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Background Videos - sliding carousel */}
      {videos.map((video, index) => (
        <div
          key={index}
          className="absolute inset-0 w-full h-full transition-opacity duration-1000"
          style={{ opacity: activeIndex === index ? 1 : 0, zIndex: 0 }}
        >
          {video.type === 'iframe' ? (
            <iframe
              src={video.src}
              allow="autoplay; fullscreen"
              className="absolute inset-0 w-full h-full"
              style={{ border: 'none', pointerEvents: 'none', transform: 'scale(1.05)' }}
              title={`Hero background video ${index + 1}`}
            />
          ) : (
            <video
              src={video.src}
              autoPlay
              muted
              loop
              playsInline
              className="absolute inset-0 w-full h-full"
              style={{ objectFit: 'cover', transform: 'scale(1.05)' }}
            />
          )}
        </div>
      ))}

      {/* Dark overlay for readability */}
      <div
        className="absolute inset-0"
        style={{ background: 'rgba(5, 15, 30, 0.35)', zIndex: 1 }}
      />

      {/* Animated background grid */}
      <div className="absolute inset-0 opacity-10" style={{ zIndex: 1 }}>
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              'linear-gradient(rgba(43,110,189,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(43,110,189,0.4) 1px, transparent 1px)',
            backgroundSize: '60px 60px',
          }}
        />
      </div>

      {/* Slide indicators */}
      <div className="absolute bottom-16 left-1/2 -translate-x-1/2 flex gap-2" style={{ zIndex: 10 }}>
        {videos.map((_, index) => (
          <button
            key={index}
            onClick={() => setActiveIndex(index)}
            className="transition-all duration-300"
            style={{
              width: activeIndex === index ? '24px' : '8px',
              height: '8px',
              borderRadius: '4px',
              background: activeIndex === index ? '#3A9A2C' : 'rgba(255,255,255,0.4)',
              border: 'none',
              cursor: 'pointer',
            }}
            aria-label={`Go to video ${index + 1}`}
          />
        ))}
      </div>

      {/* Content */}
      <div className="relative w-full max-w-7xl mx-auto px-6 py-24 flex items-center justify-start" style={{ zIndex: 2 }}>
        {/* Left text */}
        <div className="w-full text-white">
          <div
            className={`transition-all duration-700 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            <h2
              style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 400, lineHeight: 1.1 }}
              className="text-3xl sm:text-4xl md:text-5xl lg:text-5xl xl:text-6xl mb-8"
            >
              <span className="block">
                <span style={{ color: '#ffffff' }}>Grid </span>
                <span style={{ color: '#3A9A2C' }}>Global</span>
              </span>
              <span className="block" style={{ color: '#ffffff' }}>
                Commercial Brokerage LLC
              </span>
            </h2>
            <p
              style={{
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 500,
                letterSpacing: '0.12em',
                color: 'rgba(255,255,255,0.75)',
                fontSize: '0.85rem',
              }}
              className="uppercase tracking-widest mb-10 max-w-lg"
            >
              Global Investment &amp; Commercial Finance Solutions
            </p>
            <div className="flex flex-wrap gap-4">
              <a
                href="#contact"
                onClick={(e) => { e?.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="px-8 py-3.5 bg-brand-green text-white font-sans font-semibold rounded-md hover:bg-green-600 transition-all duration-200 hover:shadow-lg hover:shadow-brand-green/30 hover:-translate-y-0.5"
              >
                Get a Free Consultation
              </a>
              <a
                href="#services"
                onClick={(e) => { e?.preventDefault(); document.querySelector('#services')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="px-8 py-3.5 border border-white/30 text-white font-sans font-semibold rounded-md hover:bg-white/10 hover:border-white/60 transition-all duration-200"
              >
                Our Services
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom wave */}
      <div className="absolute bottom-0 left-0 right-0" style={{ zIndex: 3 }}>
        <svg viewBox="0 0 1440 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full">
          <path d="M0 60L60 50C120 40 240 20 360 15C480 10 600 20 720 25C840 30 960 30 1080 25C1200 20 1320 10 1380 5L1440 0V60H1380C1320 60 1200 60 1080 60C960 60 840 60 720 60C600 60 480 60 360 60C240 60 120 60 60 60H0Z" fill="white" />
        </svg>
      </div>
    </section>
  );
}
